globalThis.ConnectionList = class ConnectionList {
  constructor() {
    this.abort = new AbortController();
    this.div = document.createElement("div");
    this.div.id = "connection-list";
    document.body.append(this.div);
    addEventListener("connections", this.update.bind(this), this.abort);
    this.update();
  }

  remove() {
    this.abort.abort();
    this.div.remove();
  }

  update() {
    this.div.innerHTML = "";
    for (const profile of globalThis.WORLD.connections.values()) {
      const div = document.createElement("div");
      div.innerText = profile.name;
      this.div.append(div);
    }
  }
};
